import { Navigate, useLocation } from 'react-router-dom'

/** Keep bookmarked settings links and in-flight login resumes on the current homepage. */
export default function RetiredLandingRedirect() {
  const location = useLocation()
  return (
    <Navigate
      to={{ pathname: '/', search: location.search, hash: location.hash }}
      state={location.state}
      replace
    />
  )
}
